import { SearchOutlined } from '@ant-design/icons';
import { Card, Form, Input } from 'antd';
import TaskCategorySelect from 'app/components/Select/TaskCategorySelect/TaskCategorySelect';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ITransportFilters } from '../../types';

interface IProps {
  onFiltersChange: React.Dispatch<React.SetStateAction<ITransportFilters>>;
  filters: ITransportFilters;
}

const TransportFilters: FC<IProps> = ({ onFiltersChange, filters }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card
      title={t('TransportFilters.Title', 'Filters')}
      bordered={false}
      style={{ marginTop: 15 }}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ layout: 'vertical' }}
        requiredMark={true}
        id="transportFiltersForm"
        onValuesChange={(_, values: ITransportFilters) =>
          onFiltersChange(values)
        }
      >
        <Form.Item name="search">
          <Input
            prefix={<SearchOutlined />}
            placeholder={t('TransportFilters.Search', 'Search')}
          />
        </Form.Item>
        <Form.Item name="taskCategoryIds">
          <TaskCategorySelect allowClear={true} mode="multiple" />
        </Form.Item>
      </Form>
    </Card>
  );
};

export default TransportFilters;
